<template>
    <nav id="nav" class="navbar navbar-toggleable-sm">
        <div class="container">
            <a :href="homeLink" class="navbar-brand" v-if="carrierDetails">
                <img :src="`https://wefix-files.s3.eu-west-2.amazonaws.com/images/logos/${carrierDetails.name}/${carrierDetails.logoPath}.svg`" class="logo" :alt="`${carrierDetails.formattedName}`">
            </a>
            <template v-if="!hideProgress">
                <div class="progress-container" v-if="!isCompletePage">
                    <div class="progress">
                        <div class="progress-bar" role="progressbar" :style="progressWidth" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    <ul class="progress-steps">
                        <li class="progress-step">
                            <a @click="goToDeviceStep()" :class="{'active': isDevicePage, 'accessible': canAccessDevicePage}">{{ isApplianceRepair ? $t('bp.BookingComplete.appliance') : $t('bp.BookingComplete.devices') }}</a>
                        </li>
                        <li class="progress-step">
                            <router-link :to="{name: 'basket'}" :class="{'active': isRepairPage, 'accessible': canAccessRepairPage}">{{$t('bp.ProgressBar.repair')}}</router-link>
                        </li>
                        <li class="progress-step">
                            <router-link :to="{name: 'customerDetails'}" :class="{'active': isDetailsPage, 'accessible': canAccessDetailsPage}">{{$t('bp.ProgressBar.details')}}</router-link>
                        </li>
                        <li class="progress-step">
                            <router-link :to="{name: 'checkout'}" :class="{'active': isCheckoutPage,  'accessible': canAccessCheckoutPage}">{{$t('bp.ProgressBar.checkout')}}</router-link>
                        </li>
                    </ul>
                </div>
                <span class="basket-toggle" v-b-toggle.sidebasket :class="{'invisible': !deviceCount || isCompletePage}">
                    <span class="badge basket-count">{{ deviceCount }}</span>
                    <icon-shopping-cart size="xl"></icon-shopping-cart>
                </span>
            </template>
        </div>
    </nav>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";

    export default {
        props: {
            hideProgress: {
                type: Boolean,
                default: false
            },
        },

        computed: {
            ...mapGetters([
                'booking',
                'bookingPostcode',
                'carrier',
                'carrierDetails',
                'devices',
                'hasDevices',
                'bookingPostcodeHasBeenSet',
                'onlyOfferSamsung',
                'isApplianceRepair'
            ]),

            /** Enable Device Link */
            canAccessDevicePage() {
                return this.bookingPostcodeHasBeenSet;
            },

            /** Enable Repair Link */
            canAccessRepairPage() {
                return (this.hasDevices && this.bookingPostcodeHasBeenSet);
            },

            /** Enable Details Link */
            canAccessDetailsPage() {
                return (this.booking.date && this.bookingPostcodeHasBeenSet);
            },

            canAccessCheckoutPage() {
                return (this.booking.date && this.booking.email && this.bookingPostcodeHasBeenSet);
            },

            /** Total number of devices in the cart */
            deviceCount() {
                if (!this.devices) return 0;
                return Object.keys(this.devices).length;
            },

            homeLink() {
                switch (this.carrier) {
                    case 'wefix': {
                        return 'https://likewizerepair.co.uk';
                    }
                    case 'samsungrepair': {
                        return 'https://samsungrepair.com';
                    }
                    case 'samsungrepair-de': {
                        return 'https://samsung-repair.de';
                    }
                    case 'likewize': {
                        return 'https://likewizerepair.co.uk';
                    }
                    case 'likewize-au': {
                        return 'https://likewizerepair.com.au';
                    }
                    case 'likewize-us': {
                        return 'https://likewizerepair.com';
                    }
                    case 'appliance': {
                        return 'https://domestic-appliance-repair.likewizerepair.co.uk';
                    }
                    // case 'vodafone': {
                    //     return 'https://www.vodafone.co.uk/'
                    // }
                    default: {
                        return "/"
                    }
                }
            },

            /** Device Pages */
            isDevicePage() {
                return (this.$route.meta.pageSection === 'device');
            },

            /** Repair Pages */
            isRepairPage() {
                return (this.$route.meta.pageSection === 'repair');
            },

            /** Details Pages */
            isDetailsPage() {
                return (this.$route.meta.pageSection === 'details');
            },

            /** Checkout Pages */
            isCheckoutPage() {
                return (this.$route.meta.pageSection === 'checkout');
            },

            /** Complete Page */
            isCompletePage() {
                return (this.$route.meta.pageSection === 'complete');
            },

            /** Manage Order Page */
            isManageOrderPage() {
                return (this.$route.meta.pageSection === 'manageOrder');
            },

            /** Update the progress bar width */
            progressWidth() {
                if (this.isDevicePage) {
                    return "width: 3%";
                } else if (this.isRepairPage) {
                    return "width: 33%";
                } else if (this.isDetailsPage) {
                    return "width: 64%";
                } else if (this.isCheckoutPage) {
                    return "width: 96.5%";
                } else if (this.isCompletePage) {
                    return "width: 100%";
                }
                return null;
            },

            /** Show Basket */
            showBasket() {
                if (this.bookingPostcode && !this.isCompletePage) {
                    return true;
                }
                return false;
            },
        },

        methods: {
            ...mapActions([
                'loadTypes',
                'selectMake'
            ]),

            goToDeviceStep() {
                if (this.onlyOfferSamsung) {
                    this.selectMake({
                        id: 2
                    }).then(() => {
                        this.loadTypes();
                        this.$router.push({name: 'deviceType'});
                    })
                    return
                }

                return this.$router.push({name: 'deviceMake'});
            },
        }
    }
</script>

<style scoped>

</style>